import { DecisionKey, Decisions, SubscriptionResponse, isNull } from '@aloft/toolkit-shared';
import { Selector } from '@reduxjs/toolkit';

import { upperFirst } from 'lodash';

import { RootState } from '../../types.ts';

type CapitalSelectorKey = Capitalize<DecisionKey>;
type SelectorKey = `select${CapitalSelectorKey}`;
type FeaturesSelectors = { [key in SelectorKey]: Selector<RootState, boolean> };

const featuresSelectors: FeaturesSelectors = Object.keys(Decisions)
  .filter((key) => !key.startsWith('_'))
  .reduce(
    (acc, key) => ({
      ...acc,
      [`select${upperFirst(key)}`]: (state: RootState) => state.features[key as DecisionKey],
    }),
    {} as FeaturesSelectors,
  );

// TODO: it would be nice if subscription information was in Redux instead of a
// context, and then we wouldn't have to pass it in separately.
featuresSelectors.selectShouldAllowTrialWithoutPayment = (
  state: RootState,
  subscription: SubscriptionResponse | null,
) => {
  if (isNull(subscription)) return state.features.shouldAllowTrialWithoutPayment;

  if (!subscription.hasActiveSubscription) return false;
  if (subscription.type !== 'trialing' || subscription.hasPaymentMethod) return false;

  return state.features.shouldAllowTrialWithoutPayment;
};

export { featuresSelectors };
